import React from "react";
import { API, TOKEN_KEY } from "@/lib/api";
import { FileSpreadsheet, FileText } from "lucide-react";

/**
 * Download buttons for backend export endpoints (Excel + CSV).
 * Uses a hidden link with the bearer token via fetch -> Blob URL (so the API auth works).
 */
function buildUrl(endpoint, params) {
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, v);
  });
  const sep = qs.toString() ? "?" : "";
  return `${API}${endpoint}${sep}${qs.toString()}`;
}

async function download(endpoint, params, fallbackName) {
  const token = localStorage.getItem(TOKEN_KEY);
  const unidade = localStorage.getItem("coomflona_unidade") || "km117";
  const r = await fetch(buildUrl(endpoint, params), {
    headers: { Authorization: `Bearer ${token}`, "X-Unidade": unidade },
  });
  if (!r.ok) {
    const txt = await r.text().catch(() => "");
    throw new Error(`Falha no export (${r.status}): ${txt.slice(0, 200)}`);
  }
  const blob = await r.blob();
  const cd = r.headers.get("Content-Disposition") || "";
  const m = cd.match(/filename="?([^"]+)"?/i);
  const name = m ? m[1] : fallbackName;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function ExportButtons({ report, params, label = "Exportar" }) {
  const handle = async (fmt) => {
    try {
      await download(`/exports/${report}`, { ...(params || {}), format: fmt }, `${report}.${fmt}`);
    } catch (e) {
      // toast handled by caller
      console.error(e);
      alert(e.message);
    }
  };
  return (
    <div className="inline-flex items-center gap-2" data-testid={`export-${report}`}>
      <button
        onClick={() => handle("xlsx")}
        className="brutal-btn bg-[#1A7F37] text-white px-3 py-1.5 font-display font-bold uppercase text-[10px] tracking-widest inline-flex items-center gap-1.5"
        title="Baixar Excel"
        data-testid={`export-${report}-xlsx`}
      >
        <FileSpreadsheet className="w-3.5 h-3.5" /> Excel
      </button>
      <button
        onClick={() => handle("csv")}
        className="brutal-btn bg-white text-[#111] px-3 py-1.5 font-display font-bold uppercase text-[10px] tracking-widest inline-flex items-center gap-1.5"
        title="Baixar CSV"
        data-testid={`export-${report}-csv`}
      >
        <FileText className="w-3.5 h-3.5" /> CSV
      </button>
    </div>
  );
}

export async function downloadLabels(productIds, copies = 1) {
  await download(`/labels/products`, { ids: productIds.join(","), copies }, "etiquetas.pdf");
}
